import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { InsuranceCertificate } from 'src/app/classes/models';
import { ComplianceResultStatuses } from 'src/app/interfaces/compliance/compliance-result-statuses';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-insurance-certificate-finding-and-results',
  templateUrl: './insurance-certificate-finding-and-results.component.html',
  styleUrl: './insurance-certificate-finding-and-results.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class InsuranceCertificateFindingAndResultsComponent {
  constructor(private ToastService: ToastService) {}

  @Input() InsuranceCertificateFindingResults?: {
    [key: number]: {
      viveNamedCertHolder: ComplianceResultStatuses;
      agentSigned: ComplianceResultStatuses;
    };
  };

  @Input() InsuranceCertificatesMappedById = new Map<
    number,
    InsuranceCertificate
  >([]);

  InsuranceResultToLabelMap: {
    [key: string]: { label: string };
  } = {
    viveNamedCertHolder: {
      label: 'VIVE Named Cert Holder?'
    },
    agentSigned: {
      label: 'Agent Signed?'
    }
  };

  castStringToNumber(value: string) {
    return Number(value);
  }

  castStringAsKeyofInsuranceCertificate(value: string) {
    return value as keyof InsuranceCertificate;
  }

  getInsurancePoliciesOnCertificate(
    InsuranceCertificate: InsuranceCertificate
  ) {
    const { InsurancePolicies } = InsuranceCertificate;

    if (!InsurancePolicies) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Insurance Certificate is missing Insurance Policies.',
        { returnError: true }
      );
    }

    return InsurancePolicies.map((InsurancePolicy) => {
      const { policyType } = InsurancePolicy;

      if (!policyType) {
        throw this.ToastService.addErrorToast(
          'Error',
          'Insurance Policy is missing policy types.',
          { returnError: true }
        );
      }

      return policyType;
    });
  }
}
